// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBCdfwEfBx8Fvq5C9s_r8Mr-re26D5tLI8",
  authDomain: "mymap-miklats.firebaseapp.com",
  projectId: "mymap-miklats",
  storageBucket: "mymap-miklats.appspot.com",
  messagingSenderId: "438542652002",
  appId: "1:438542652002:web:954c92e78eef43d2ee773b",
  measurementId: "G-10CK7P2B02",
};

// Initialize Firebase
export const app: FirebaseApp = initializeApp(firebaseConfig);

export const db = getFirestore(app);
